import React, {Component} from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import '../scss/PDFToolbar.scss'
import singletrackIcon from '../img/singletrack-logo-icon.svg'


class PDFToolbar extends Component {
    constructor (props) {
        super(props)
    }

    handleCurrentPageClick = (e) => {
        e.target.setSelectionRange(0, e.target.value.length)
    }

    handleCurrentPageChange = (e) => {
        if (!e.target.value) return;
        this.props.onPageChange(parseInt(e.target.value, 10))
    }

    getClientNamePart() {
        return this.props.client ? `${this.props.client}: ` : '';
    }

    getTotalPages() {
        return this.props.totalPages || '…';
    }

    getAttributionUri() {
        return 'https://singletrack.com/?ref=re'
    }

    getDisplayedLoadingProgress() {
        return this.props.loadingProgress ? Math.round(-(100 - this.props.loadingProgress)) : -100;
    }

    getProgressBarStyle() {
        return this.props.loadingProgress >= 100
            ? { opacity: 0, visibility: 'hidden' }
            : { opacity: 1, visibility: 'visible' };
    }

    render() {
        return (
            <div className="PDFToolbar">
                <div className="PDFToolbar-grid">
                    <div className="PDFToolbar-title">
                        <span className="PDFToolbar-client-name">
                            {this.getClientNamePart()}
                        </span>
                        <span className="PDFToolbar-document-title">
                            {this.props.title}
                        </span>
                    </div>
                    {this.props.totalPages &&
                    <div className="PDFToolbar-navigation">
                        <div className="PDFToolbar-navigation-current-page">
                            <input type="text" value={this.props.currentPage} onChange={this.handleCurrentPageChange}
                                   onClick={this.handleCurrentPageClick} onFocus={this.handleCurrentPageClick}/>
                        </div>
                        <div className="PDFToolbar-navigation-separator">
                            /
                        </div>
                        <div className="PDFToolbar-navigation-total-pages">
                            {this.props.totalPages}
                        </div>
                    </div>
                    }
                    <div className="PDFToolbar-utilities-attribution">
                        <div className="PDFToolbar-utilities">
                            {this.props.viewerPermissions && this.props.viewerPermissions.print &&
                            <button title="Print document" onClick={this.props.handlePrintClick}>
                                <FontAwesomeIcon icon="print" size="lg" />
                            </button>
                            }
                            {this.props.viewerPermissions && this.props.viewerPermissions.download &&
                            <button title="Download document" onClick={this.props.handleDownloadClick}>
                                <FontAwesomeIcon icon="download" size="lg" />
                            </button>
                            }
                        </div>
                        <div className="PDFToolbar-attribution">
                            <span className="PDFToolbar-attribution-label">
                                <a href={this.getAttributionUri()} target="_blank" onClick={this.props.onAttributionClick}>
                                    {this.props.attribution}
                                </a>
                            </span>
                            <div className="PDFToolbar-attribution-logo">
                                <a href={this.getAttributionUri()} target="_blank" onClick={this.props.onAttributionClick}>
                                    <img src={singletrackIcon} alt="Singletrack"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="PDFToolbar-progress-bar" style={this.getProgressBarStyle()}>
                    <div className="PDFToolbar-progress-bar-bar"
                         style={{transform: `translateX(${this.getDisplayedLoadingProgress()}%)`}}>
                    </div>
                </div>
            </div>
        )
    }
}

export default PDFToolbar
